<template>
  <div>
    <b-form novalidate @submit.prevent="onSubmit">
      <b-row>
        <b-col xs="12" md="6">
          <b-card class="mt-3">
            <h4 slot="header">Details</h4>
            <text-control label="User Name" description="The user must have an existing account and user name. For most users, their user name is their email address." v-model="item.applicationUser.userName" required :disabled="isUpdate || !isEditable" :custom-validation="validateUserName"></text-control>
            <select-control label="Station" v-model="item.station.id" required :options="stations" :disabled="isUpdate || !isEditable"></select-control>
            <select-control label="Type" description="Sets what level of access the user has to the station" v-model="item.type" required :options="roleTypes" :disabled="!isEditable"></select-control>
          </b-card>
        </b-col>
        <b-col xs="12" md="6">
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <b-button-toolbar key-nav>
            <b-button-group v-if="isEditable">
              <b-button type="submit" variant="primary">
                <slot name="save"></slot>
              </b-button>
            </b-button-group>
            <b-button-group class="mx-2">
              <b-button type="button" @click="onCancel">Cancel</b-button>
            </b-button-group>
            <slot name="buttons" v-if="isEditable"></slot>
          </b-button-toolbar>
        </b-col>
      </b-row>
      
    </b-form>
  </div>
</template>

<script>
import CrudOperationsMixin from '../Common/CrudOperationsMixin.js'
import Constants from '../Common/Constants.js'

export default {
  name: "RoleFields",
  mixins: [CrudOperationsMixin],
  props: [
    'item',
    'isUpdate',
    'isEditable'
  ],
  data() {
    return {
      stations: [],
      roleTypes: Constants.roleTypes
    };
  },
  methods: {
    loadStations() {
      this.readQuery('/graphql/management', {
        query: `
          query {
            stations (limit: 1000, order: "displayCity") {
              id,
              name,
              displayCity,
              state
            }
          }`,
        variables: { }
      }, (data) => {
        this.stations = data.stations.filter(s => s.displayCity).map(s =>  {
          return {
            value: s.id,
            text: s.displayCity + (s.state ? ', ' + s.state : '') + ': ' + s.name
          };
        });
      });
    },
    validateUserName(newValue, oldValue, revalidateFunction) {
      if (!oldValue && !newValue) {
        if (this.item.applicationUser.id)
          return true;
        else
          return "There's no existing user with that user name";
      } else if (oldValue == newValue) {
        return true;
      } else {
        this.query('/graphql/management', {
          query: `
            query ($userName: String) {
              verifyUserName (userName: $userName)
            }`,
          variables: {
            'userName': this.item.applicationUser.userName
          }
        }, (data) => {
          if (data.verifyUserName) {
            this.item.applicationUser.id = data.verifyUserName;
            revalidateFunction();
          } else {
            this.item.applicationUser.id = null;
            revalidateFunction();
          }
        }, (data) => {}, false, false, false);
        return 'Looking up username...'
      }
    },
    onCancel(evt) {
      this.$emit('cancel');
    },
    onSubmit(evt) {
      // Make sure all the child components are valid
      if (this.$children.every(childComponent => { return typeof(childComponent.isValid) === 'undefined' || childComponent.isValid; }))
        this.$emit('submit');
    },
  },
  mounted () {
    this.loadStations();
  }
};
</script>